import type { HTMLAttributes, ReactNode } from 'react'
import { SHELL_INDEX_ROW_CLASS } from '@/lib/shell-chrome'
import { cn } from '@/lib/utils'

export type ShellIndexRowProps = Omit<HTMLAttributes<HTMLDivElement>, 'title'> & {
  /** Kind icon, back button, or filter trigger. */
  leading?: ReactNode
  /** Truncates. Omit when `children` lays out the row itself. */
  title?: ReactNode
  /** Right-aligned controls. */
  trailing?: ReactNode
  testId?: string
}

/**
 * The 44px index line with a bottom hairline. Folder filter rows, peek headers,
 * People title rows, and the info-dock heading all sit on it, so the list and
 * the peek share one line. Gallery: /?test=maater-ui#panel-collapse
 */
export function ShellIndexRow({
  leading,
  title,
  trailing,
  testId,
  className,
  children,
  ...rest
}: ShellIndexRowProps) {
  return (
    <div
      data-testid={testId}
      className={cn(
        SHELL_INDEX_ROW_CLASS,
        'flex min-w-0 shrink-0 items-center gap-2 border-b border-border px-4',
        className,
      )}
      {...rest}
    >
      {leading ? <span className="flex shrink-0 items-center">{leading}</span> : null}
      {title ? <div className="min-w-0 flex-1 truncate text-sm font-semibold">{title}</div> : null}
      {children}
      {trailing ? <div className="ml-auto flex shrink-0 items-center gap-1">{trailing}</div> : null}
    </div>
  )
}
